import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import extend from 'lodash/extend';
import omit from 'lodash/omit';
import App from '../components/App.jsx';

// DO NOT COMMENT THIS LINE, it works globally
// eslint-disable-next-line no-unused-vars
import ColorPropsPlugin from '../../../node_modules/gsap/src/uncompressed/plugins/ColorPropsPlugin';

const propTypes = {
    stage: PropTypes.object.isRequired,
    crisis: PropTypes.object.isRequired,
};

const AppContainer = (props) => {
    const stage = props.stage.toJS();
    const crisis = props.crisis.toJS();
    const cleanProps = omit(props, ['stage', 'crisis']);

    return (
        <App
            {...cleanProps}
            stage={stage}
            crisis={crisis}
        />
    );
};

AppContainer.propTypes = propTypes;

module.exports = connect((state) => {
    return {
        stage: state.stage,
        crisis: state.crisis,
    };
}, null, (stateProps, dispatchProps, parentProps) => {
    return extend({}, parentProps, stateProps, dispatchProps);
})(AppContainer);



// WEBPACK FOOTER //
// ./js/containers/App.jsx